// node_modules
import { RefObject, useEffect, useState } from "react";

export const useIsOnScreen = (elementRef: RefObject<HTMLElement>): {isOnScreen: boolean} => {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const intersectionObserver = new IntersectionObserver(
            ([entry]) => setIntersecting(entry.isIntersecting)
        );

        // safety-checks
        if (!elementRef || !elementRef.current) { return; }

        intersectionObserver.observe(elementRef.current);

        return () => { intersectionObserver.disconnect(); };
    }, [elementRef]);

    return { isOnScreen: isIntersecting };
};
